module.exports = __webpack_public_path__ + "img/gift4-01-c08-y1.6abe3049.png";